import React from 'react';
import webapi from '../../../api/webapi';
import LoadingGif from '../../images/loading.gif';


export default class img2 extends React.Component {
    state = { Image: '' };

    componentDidMount() {
        this.getPage();
    }

    async getPage() {
        const ImageConst = await webapi.get('pages/image/'+this.props.ImageCode);
        //console.log(this.props.ImageCode);
        //console.log(ImageConst.data[0].Logo);
        this.setState({
            Image: ImageConst.data[0].Logo
        });
    }

    render() {
        return (
            (this.state.Image || this.state.Image===undefined)
            ?
                (this.state.Image==null || this.state.Image===undefined)
                ?
                    <div style={{height:'130px'}}></div>
                :
                    <img alt="a" className={this.props.Class} src= {"data:image/png;base64,"+this.state.Image} />
            :
                <img alt='loading...' className={this.props.Class} src={LoadingGif} />
        )
    }
}